import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from "chart.js"

Chart.register(...registerables)

export default class extends Controller {
  static values = {
    labels: Array,
    sent: Array,
    opened: Array,
    clicked: Array
  }

  connect() {
    this.initChart()

    this.beforeCacheHandler = this.teardown.bind(this)
    document.addEventListener("turbo:before-cache", this.beforeCacheHandler)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCacheHandler)
    this.teardown()
  }

  initChart() {
    if (this.chart) {
      this.chart.destroy()
    }

    const ctx = this.element.getContext("2d")

    this.chart = new Chart(ctx, {
      type: "line",
      data: {
        labels: this.labelsValue,
        datasets: [
          {
            label: "Wysłano",
            data: this.sentValue,
            borderColor: "rgb(107, 114, 128)",
            backgroundColor: "rgba(107, 114, 128, 0.1)",
            tension: 0.3,
            fill: true
          },
          {
            label: "Otwarto",
            data: this.openedValue,
            borderColor: "rgb(20, 184, 166)",
            backgroundColor: "rgba(20, 184, 166, 0.1)",
            tension: 0.3,
            fill: true
          },
          {
            label: "Kliknięto",
            data: this.clickedValue,
            borderColor: "rgb(59, 130, 246)",
            backgroundColor: "rgba(59, 130, 246, 0.1)",
            tension: 0.3,
            fill: true
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "bottom"
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              stepSize: 1
            }
          }
        }
      }
    })
  }

  teardown() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
